import axios from '../api/axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

export interface SecretaryLoginResponse {
    message: string;
    secretary: {
        id: number;
        email: string;
        nom: string;
        prenom: string;
        entrepriseUserId: number;
        solde: number;
        sharedPercentageReferral: number;
    };
    token: string;
    entreprise: {
        id: number;
        name: string;
        firstname: string;
        email: string;
        raison_social?: string;
        is_entreprise?: boolean;
    };
}

// Connexion secrétaire
export const loginSecretary = async (email: string, password: string): Promise<SecretaryLoginResponse> => {
    try {
        console.log('🔐 Tentative de connexion secrétaire:', { email, apiUrl: API_URL });
        
        const response = await axios.post(`${API_URL}/secretary/login`, { 
            email, 
            password 
        });

        console.log('✅ Réponse serveur:', response.status, response.data);

        if (response.status === 200 && response.data) {
            const { secretary, token, entreprise } = response.data;
            
            // Sauvegarder les infos du secrétaire
            localStorage.setItem('secretaryId', secretary.id.toString());
            localStorage.setItem('secretaryEmail', secretary.email);
            localStorage.setItem('secretaryName', `${secretary.prenom} ${secretary.nom}`);
            localStorage.setItem('entrepriseId', secretary.entrepriseUserId.toString());
            localStorage.setItem('token', token);
            localStorage.setItem('role', 'SECRETARY');
            
            // Infos de l'entreprise parente
            const entrepriseName = entreprise.is_entreprise 
                ? entreprise.raison_social 
                : `${entreprise.firstname} ${entreprise.name}`;
            
            localStorage.setItem('entrepriseName', entrepriseName || '');
            localStorage.setItem('entrepriseEmail', entreprise.email);

            console.log('✅ Données sauvegardées dans localStorage');

            return response.data;
        } else {
            throw new Error("Réponse serveur invalide");
        }
    } catch (error: any) {
        console.error("❌ Erreur loginSecretary:", error.response?.data || error.message);
        
        // Propager l'erreur pour que le composant puisse l'afficher
        if (error.response?.data?.message) {
            throw error;
        } else {
            throw new Error("Erreur de connexion au serveur");
        }
    }
};

// Récupérer les informations du secrétaire connecté
export const getSecretaryInfo = async (secretaryId: number) => {
    try {
        const response = await axios.get(`${API_URL}/enterprise-team/id/${secretaryId}`);
        return response.data;
    } catch (error) {
        console.error("Erreur getSecretaryInfo:", error);
        throw error;
    }
};

// Mettre à jour le mot de passe du secrétaire
export const updateSecretaryPassword = async (secretaryId: number, newPassword: string) => {
    try {
        const response = await axios.put(`${API_URL}/secretary/${secretaryId}/password`, {
            password: newPassword
        });
        return response.data;
    } catch (error) {
        console.error("Erreur updateSecretaryPassword:", error);
        throw error;
    }
};

// Créer une demande de retrait pour le secrétaire
export const createSecretaryRefund = async (data: {
    rib: string;
    bic?: string;
    amount: number;
    reason?: string;
}) => {
    try {
        const response = await axios.post(`${API_URL}/refunds`, {
            rib: data.rib,
            bic: data.bic,
            amount: data.amount,
            reason: data.reason || 'Demande de retrait secrétaire'
        });
        return response;
    } catch (error) {
        console.error("Erreur createSecretaryRefund:", error);
        throw error;
    }
};

// Récupérer l'historique des retraits du secrétaire
export const getSecretaryRefunds = async (secretaryId: number) => {
    try {
        const response = await axios.get(`${API_URL}/refunds/secretary/${secretaryId}`);
        return response;
    } catch (error) {
        console.error("Erreur getSecretaryRefunds:", error);
        throw error;
    }
};